import React from 'react';
import { navigate } from 'gatsby';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Button from 'components/Core/Button';
import { navigationEvent } from 'services/dataLayerService';
import { NavItem, NavItemsContainer, SolutionNavItemsContainer, ButtonsContainer } from './styles';

const ParentNav = ({ navigationMenu, handleSubMenu }) => {
  const getBusinessTypesSet = (root) => Array.from(new Set(root.map((x) => x.businessType)));

  const solutionsFirstMenu = [
    ...navigationMenu.filter((obj) => obj.label === 'Solutions'),
    ...navigationMenu.filter((obj) => obj.label !== 'Solutions'),
  ];

  const businessTypeDescriptions = {
    Commercial:
      'Power your way to more productive workflows, better profit margins, and a faster speed to cash.',
    Residential:
      'Empower your team, gain more insights, and impress homeowners at every part of the job cycle.',
  };

  return (
    <div className="mobile-parent-nav">
      <NavItemsContainer>
        {solutionsFirstMenu.map((navEle, index) => (
          <>
            <NavItem
              onClick={
                navEle.label === 'Solutions'
                  ? null
                  : !navEle.subNavigationElement
                  ? () => {
                      navigate(navEle.url);
                      navigationEvent(navEle.label, navEle.url);
                    }
                  : () => {
                      navigationEvent(navEle.label, navEle.url);
                      handleSubMenu(navEle);
                    }
              }
              label={navEle.label}
              index={index}
            >
              <div>
                <p className="nav-item--title font-sm">
                  <b>{navEle.label}</b>
                </p>
              </div>
              {navEle.label !== 'Solutions' && navEle.subNavigationElement && (
                <div className="arrow-container">
                  <ArrowForwardIosIcon />
                </div>
              )}
            </NavItem>
            {navEle.label === 'Solutions' && (
              <SolutionNavItemsContainer>
                {getBusinessTypesSet(navEle.subNavigationElement).map((businessType, idx) => (
                  <div
                    className="solutions-nav-item"
                    role="button"
                    tabIndex={0}
                    onClick={() => {
                      handleSubMenu({
                        ...navEle,
                        subNavigationElement: navEle.subNavigationElement.filter(
                          (ele) => ele.businessType === businessType,
                        ),
                      });
                      navigationEvent(businessType);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        e.target.click();
                      }
                    }}
                    key={idx}
                  >
                    <div className="solutions-nav-item--copy">
                      <p className="solutions-nav-item--title font-p">
                        <b>{businessType}</b>
                      </p>
                      <p className="font-sm">{businessTypeDescriptions[businessType]}</p>
                    </div>
                    <div className="solutions-arrow-container">
                      <ArrowForwardIosIcon />
                    </div>
                  </div>
                ))}
              </SolutionNavItemsContainer>
            )}
          </>
        ))}
        <ButtonsContainer>
          <Button
            dataPosition="Header - Menu Item CTA"
            className="header-menu-cta upgrade-btn"
            type="tertiary"
            shadow={false}
            to="/features/pro"
            onClick={() => navigationEvent('Upgrade to Pro Products', '/features/pro')}
          >
            <p className="font-sm">
              <b>Upgrade to Pro Products</b>
            </p>
          </Button>
          <Button
            dataPosition="Header - Menu Item CTA"
            className="header-menu-cta sign-in-btn"
            type="transparent - black border"
            shadow={false}
            to="https://go.servicetitan.com/auth/externallogin"
            onClick={() =>
              navigationEvent('Sign In', 'https://go.servicetitan.com/auth/externallogin')
            }
          >
            <p className="font-sm">
              <b>Sign In</b>
            </p>
          </Button>
          <Button
            className="mt-[20px]"
            dataPosition="Header - Menu Item CTA"
            type="ghost"
            shadow={false}
            to="/customer-resource-hub"
            onClick={() => navigationEvent('Customer Resource Hub', '/customer-resource-hub')}
          >
            <p className="font-sm">
              <b>Customer Resource Hub</b>
            </p>
          </Button>
        </ButtonsContainer>
      </NavItemsContainer>
    </div>
  );
};

export default ParentNav;
